<div class="input-group flex-nowrap">
  <input type="file" #fileInput [accept]="acceptedFileTypes" (change)="onValueChange($event)" class="form-control form-control-lg" />
  <a *ngIf="allowCamera" (click)="photoCameraModal()" class="input-group-text bg-primary text-white px-3 border-primary"><i class="bi bi-camera fw-bold"></i> </a>
</div>
